module.exports = __webpack_public_path__ + "img/18.14dc1c51.svg";